module.exports = __webpack_public_path__ + "media/images/symbols/burger-9182849401cde142cd252f2a65d0cbdf.svg";